import { Directive } from '@angular/core';

/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @angular-eslint/directive-class-suffix */

/** Hint text to be displayed for a modus-form-field. */
@Directive({
  selector: 'modus-hint',
  standalone: false,
})
export class ModusHint {}
